import InterviewScriptTemplates from './InterviewScriptTemplates';

export default InterviewScriptTemplates;
